import { Box, Typography } from "@material-ui/core";
import ToolkitTable from "components/Cards/Tables/ToolkitTable";
import LoadingData from "components/Loading/LoadingData";
import { columnTextField } from "utils/tables-utils";
import themeColorsDesingSystem from "assets/theme/ds-colors";
import {
  getTypeLabel,
  getStatusLabel,
  formatDate,
  TYPE_STYLE,
  STATUS_STYLE,
} from "../constants";
import ContentActionsMenu from "./content-actions-menu";

export default function ContentTable({ data, loading, onAction }) {
  const columnModel = [
    columnTextField({
      dataField: "titulo",
      text: "Conteúdo",
      headerAlign: "left",
      align: "left",
      formatter: (_, row) => (
        <Box style={{ display: "flex", alignItems: "center", gap: 20 }}>
          <img
            src={row.thumbnail}
            alt={row.titulo}
            style={{
              borderRadius: 10,
              width: 150,
              height: 75,
              objectFit: "cover",
            }}
          />
          <Box>
            <Typography
              variant="subtitle2"
              style={{
                fontWeight: 600,
                color: themeColorsDesingSystem.text.primary,
              }}
            >
              {row.titulo}
            </Typography>
            <Typography
              variant="caption"
              style={{ color: themeColorsDesingSystem.gray.main }}
            >
              {row.descricao}
            </Typography>
          </Box>
        </Box>
      ),
    }),

    columnTextField({
      dataField: "tipo",
      text: "Tipo",
      headerAlign: "left",
      align: "left",
      formatter: (_, row) => {
        const s = TYPE_STYLE[row.tipo] || { bg: "#f5f5f5", color: "#616161" };
        return (
          <Box
            style={{
              display: "inline-block",
              padding: "4px 10px",
              borderRadius: 6,
              backgroundColor: s.bg,
              color: s.color,
              fontSize: "0.75rem",
              fontWeight: 600,
            }}
          >
            {getTypeLabel(row.tipo)}
          </Box>
        );
      },
    }),
    columnTextField({
      dataField: "categoria",
      text: "Categoria",
      headerAlign: "left",
      align: "left",
      formatter: (_, row) => (
        <Typography
          variant="body2"
          style={{ color: themeColorsDesingSystem.text.primary }}
        >
          {row.categoria}
        </Typography>
      ),
    }),
    columnTextField({
      dataField: "status",
      text: "Status",
      headerAlign: "left",
      align: "left",
      formatter: (_, row) => {
        const s = STATUS_STYLE[row.status] || STATUS_STYLE.RASCUNHO;
        return (
          <Box
            style={{
              display: "inline-block",
              padding: "4px 10px",
              borderRadius: 6,
              backgroundColor: s.bg,
              color: s.color,
              fontSize: "0.75rem",
              fontWeight: 600,
            }}
          >
            {getStatusLabel(row.status)}
          </Box>
        );
      },
    }),
    columnTextField({
      dataField: "periodo",
      text: "Período",
      headerAlign: "left",
      align: "left",
      formatter: (_, row) => {
        if (!row.dataInicio && !row.dataFim) return "-";
        const format = (d) => {
          if (!d) return "";
          const [y, m, day] = d.split("-");
          return `${day}/${m}/${y}`;
        };

        return (
          <Box>
            <Typography
              variant="body2"
              style={{
                color: themeColorsDesingSystem.text.primary,
                whiteSpace: "break-spaces",
              }}
            >
              {format(row.dataInicio)}
            </Typography>
            <Typography
              variant="body2"
              style={{
                color: themeColorsDesingSystem.text.primary,
                whiteSpace: "break-spaces",
              }}
            >
              à {format(row.dataFim)}
            </Typography>
          </Box>
        );
      },
    }),
    columnTextField({
      dataField: "atualizadoPor",
      text: "Atualizado por",
      headerAlign: "left",
      align: "left",
      formatter: (_, row) => (
        <Box>
          <Typography
            variant="body2"
            style={{ color: themeColorsDesingSystem.text.primary }}
          >
            {row.atualizadoPor}
          </Typography>
          <Typography
            variant="caption"
            style={{ color: themeColorsDesingSystem.gray.main }}
          >
            {formatDate(row.dataAtualizacao)}
          </Typography>
        </Box>
      ),
    }),
    columnTextField({
      dataField: "acoes",
      text: "Ações",
      headerAlign: "center",
      align: "center",
      formatter: (_, row) => (
        <ContentActionsMenu row={row} onAction={onAction} />
      ),
    }),
  ];

  if (loading) {
    return <LoadingData searching label="Carregando conteúdos..." />;
  }

  return (
    <ToolkitTable
      keyField="id"
      dataTable={data}
      columnModel={columnModel}
      notFoundTitle="Nenhum conteúdo encontrado com os filtros aplicados."
      pagination={{
        options: [10, 25, 50],
        defaultOption: 10,
        showTotal: true,
      }}
    />
  );
}
